var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-integration-card',{attrs:{"integration":_vm.notionIntegration,"loading":_vm.loading,"lg":"","sales":"","tool":"notion"},on:{"onConnect":_vm.connect,"onDisconnect":_vm.disconnect}})
}
var staticRenderFns = []

export { render, staticRenderFns }